import React from 'react';
import { ImagePlaceholder, SectionWrapper } from './ui';
import { CheckCircle2 } from 'lucide-react';
export const FounderBlock = () => {
  return <SectionWrapper className="py-8 bg-background" data-id="element-372">
      <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-373">
        <div className="w-24 h-24 md:w-32 md:h-32 shrink-0 rounded-full overflow-hidden border-2 border-sage" data-id="element-374">
          <img src="https://cdn.magicpatterns.com/uploads/hvvgB3LKwo7BchdqmM3QJ8/2e636a3a-a0a5-4808-b6ce-3b7ae0056c00.png" alt="Marcus Hale, industrial designer and founder of LEVANCE, photographed in his workshop" className="w-full h-full object-cover object-top" data-id="element-375" />
        </div>

        <div className="flex-1" data-id="element-376">
          <div className="mb-4" data-id="element-377">
            <h3 className="font-bold text-lg flex items-center flex-wrap gap-2" data-id="element-378">
              Marcus Hale — Industrial Designer · Father
              <span className="inline-flex items-center text-primary text-sm bg-sage/30 px-2 py-0.5 rounded-full" data-id="element-379">
                <CheckCircle2 className="w-4 h-4 mr-1 text-primary" data-id="element-380" />
                Founder, LEVANCE™
              </span>
            </h3>
          </div>

          <div className="space-y-5 text-[17px] leading-[1.6] text-foreground/90" data-id="element-381">
            <p data-id="element-382">
              My name is Marcus Hale. I'm an industrial designer, and I am the
              father of a six-year-old girl who failed her alpha-gal IgE panel
              after a tick bite we thought we had handled.
            </p>
            <p data-id="element-383">
              I spent fifteen years designing consumer hardware — health
              wearables, outdoor electronics, the kind of products that end up
              at REI. I am not a doctor. I am not an entomologist. I am the dad
              in the parking lot at soccer practice scanning his daughter's
              ankles, the same as you.
            </p>
            <p data-id="element-384">
              What I am is the guy who spent eighteen months on the phone with
              Lyme researchers, entomologists, and Scandinavian veterinarians
              who have been quietly recommending ultrasonic clips to dog owners
              for over a decade. I logged hundreds of hours of conversations
              with parents who told me the same three things:
            </p>

            <div className="bg-sage/20 border border-sage p-6 rounded-sm my-6 space-y-4" data-id="element-385">
              <div className="flex gap-4" data-id="element-386">
                <span className="font-serif text-accent font-bold text-xl" data-id="element-387">
                  1
                </span>
                <p className="italic font-medium" data-id="element-388">
                  "I'm doing everything right and I'm still finding ticks."
                </p>
              </div>
              <div className="flex gap-4" data-id="element-389">
                <span className="font-serif text-accent font-bold text-xl" data-id="element-390">
                  2
                </span>
                <p className="italic font-medium" data-id="element-391">
                  "I hate DEET but I hate Lyme more — and now I'm hearing about
                  alpha-gal."
                </p>
              </div>
              <div className="flex gap-4" data-id="element-392">
                <span className="font-serif text-accent font-bold text-xl" data-id="element-393">
                  3
                </span>
                <p className="italic font-medium" data-id="element-394">
                  "The mental load never turns off."
                </p>
              </div>
            </div>

            <p data-id="element-395">
              That's the condition I built LEVANCE for. Not "bug bites." That.
              The cognitive tax. The 11:14 p.m. flashlight-on-the-freckle. The
              grief of a childhood that doesn't look like yours did.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};
export const SymptomStrip = () => {
  return <SectionWrapper className="py-8" isWide={true} data-id="element-396">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-397">
        <figure className="w-full flex flex-col" data-id="element-398">
          <div className="w-full aspect-square md:aspect-[4/3] overflow-hidden rounded-sm border border-sage" data-id="element-399">
            <img src="https://cdn.magicpatterns.com/uploads/9JwYXp9j9uvScfBHByHf6s/186c0f6d-a0f3-4549-9076-88ba0c33ee54.png" alt="Mother's hands parting a six-year-old's thick hair under bathroom vanity light, searching for ticks" className="w-full h-full object-cover" data-id="element-400" />
          </div>
          <figcaption className="mt-3 text-sm italic text-foreground/80 text-center px-4" data-id="element-401">
            Every Freckle on Her Scalp Looks Like a Tick to Me Now.
          </figcaption>
        </figure>
        <figure className="w-full flex flex-col" data-id="element-402">
          <div className="w-full aspect-square md:aspect-[4/3] overflow-hidden rounded-sm border border-sage" data-id="element-403">
            <img src="https://cdn.magicpatterns.com/uploads/urLSMAeXcAeXKYxyxsB9jJ/0d72ee1f-eae8-49fc-a771-5a75b053241d.png" alt="Picaridin pump-spray bottle on a mudroom console table with kids' soccer cleats and a pink boot in morning light" className="w-full h-full object-cover" data-id="element-404" />
          </div>
          <figcaption className="mt-3 text-sm italic text-foreground/80 text-center px-4" data-id="element-405">
            The Morning Spray Ritual That Never Feels Like Enough
          </figcaption>
        </figure>
        <figure className="w-full flex flex-col" data-id="element-406">
          <div className="w-full aspect-square md:aspect-[4/3] overflow-hidden rounded-sm border border-sage" data-id="element-407">
            <img src="https://cdn.magicpatterns.com/uploads/7gdwoGoSrmKWqG2SHzsobE/2b0220d0-ee6e-4fd0-844c-4c40b61e4b2d.png" alt="Golden retriever on a kitchen island mid-belly-check, owner's hands running through fur" className="w-full h-full object-cover" data-id="element-408" />
          </div>
          <figcaption className="mt-3 text-sm italic text-foreground/80 text-center px-4" data-id="element-409">
            Three Off the Dog This October Alone
          </figcaption>
        </figure>
        <figure className="w-full flex flex-col" data-id="element-410">
          <div className="w-full aspect-square md:aspect-[4/3] overflow-hidden rounded-sm border border-sage" data-id="element-411">
            <img src="https://cdn.magicpatterns.com/uploads/n6tYs7i9Sy1SHceTEAfABs/b5a63321-27be-481c-b9b7-583ca42f180e.png" alt="Mother in bed at night examining her arm with phone flashlight, husband asleep beside her in cool blue tones" className="w-full h-full object-cover" data-id="element-412" />
          </div>
          <figcaption className="mt-3 text-sm italic text-foreground/80 text-center px-4" data-id="element-413">
            11:14 p.m. — The Freckle That Won't Let You Sleep
          </figcaption>
        </figure>
      </div>
    </SectionWrapper>;
};
export const ProblemSection = () => {
  return <SectionWrapper className="py-8" data-id="element-414">
      <div className="space-y-6 text-[17px] leading-[1.6] text-foreground/90" data-id="element-415">
        <p data-id="element-416">
          You've sprayed them like a pesticide truck. You've treated the
          clothes. You've done the scalp comb, the lint roll, the after-soccer
          strip in the garage. You've paid $640 for the yard service that
          doesn't extend to the school field. You've thrown out a clip-on whose
          battery died in your tackle box, and a bottle of lemon eucalyptus you
          knew in your gut was theater.
        </p>
        <p data-id="element-417">
          You've sat in the pediatrician's office hearing "probably a spider
          bite" and not slept right since.
        </p>
        <p data-id="element-418">
          You name it. I've heard it. From hundreds of parents who look exactly
          like you, in towns that look exactly like yours, who are doing
          everything right — and still finding ticks. You are not the paranoid
          one. You're the early one.
        </p>
      </div>

      <div className="bg-sage/30 border-y border-sage py-8 my-10 px-6 -mx-5 sm:mx-0 sm:rounded-sm sm:border-x" data-id="element-419">
        <h2 className="text-2xl md:text-3xl font-serif text-primary leading-tight text-center" data-id="element-420">
          The Tick Problem Isn't Just Annoying… It Steals Your Summer, Your
          Sleep, and Your Family's Future Relationship With the Outdoors — One
          Background Worry at a Time.
        </h2>
      </div>

      <div className="space-y-6 text-[17px] leading-[1.6] text-foreground/90" data-id="element-421">
        <p data-id="element-422">
          Here's what nobody told you, and it's the single piece of information
          that reframes every spray bottle, every comb, every 11 p.m. flashlight
          check you've done in the last five years.
        </p>
        <p data-id="element-423">
          The rules of tick protection that you grew up with don't apply
          anymore. The long socks. The DEET. The tick check at the end of the
          day. The "stay out of tall grass." All of that was built for one tick
          — the blacklegged deer tick — and one disease, Lyme. That tick had
          rules. It was a passive quester. It climbed to the top of a blade of
          grass, held out its front legs, and waited. You could see it. Check
          for it. Manage it.
        </p>

        <div className="my-8" data-id="element-424">
          <div className="w-full aspect-[16/9] overflow-hidden rounded-sm border border-sage" data-id="element-425">
            <img src="https://cdn.magicpatterns.com/uploads/o56RNo5yfxfbMuMtJqkGNm/15374b8d-41d0-4c05-a88d-8e3b5f2ec810.png" alt="Scientific illustration of a tick in questing position on a blade of grass with ultrasonic disruption wave rings emanating nearby" className="w-full h-full object-cover" data-id="element-426" />
          </div>
        </div>

        <p data-id="element-427">
          That tick is still here. But it has company now. The Lone Star tick —
          once a quiet Southern pest — has swept north into Connecticut,
          Massachusetts, New York, Pennsylvania, Michigan, Wisconsin, and is
          showing up in places that twenty years ago would have laughed at the
          idea. And the Lone Star tick does not wait. It hunts. Entomologists
          call them "aggressive questers." They actively pursue the carbon
          dioxide your child exhales. They cover ground the deer tick never
          could.
        </p>
        <p data-id="element-428">
          And when a Lone Star tick bites, it can leave behind a sugar molecule
          called alpha-gal that rewires the human immune system to attack red
          meat, dairy, and the gelatin in medications — for life. The CDC now
          estimates as many as 450,000 Americans may already have alpha-gal
          syndrome, and most of them don't know it yet. They just think they've
          been feeling weird after dinner.
        </p>

        <div className="pl-6 border-l-4 border-accent my-8" data-id="element-429">
          <p className="text-xl font-serif text-primary italic leading-relaxed" data-id="element-430">
            "So if you've been spraying, checking, combing, and still finding
            ticks — it's not because you've been doing it wrong. It's because
            you've been doing it outdated."
          </p>
        </div>

        <p data-id="element-431">
          The playbook you inherited from your parents was written for a world
          that no longer exists. The threat changed. The defense didn't. You're
          the first generation of parents who has to defend a family against a
          tick that hunts your children and can rewrite their immune system for
          life.
        </p>
        <p data-id="element-432">
          That's the gap. And until somebody closes it for you, no amount of
          vigilance is going to give you back the summer.
        </p>
        <p data-id="element-433">
          There is a way to close it. It doesn't come from a chemical company.
          It doesn't come from your pediatrician. And it's been sitting in
          European veterinary research for over a decade…
        </p>
      </div>
    </SectionWrapper>;
};